module.exports = __webpack_public_path__ + "img/half-separator.12ad304e.svg";